import { formatStripeSubscriptionInterval } from "./format-stripe-subscription-interval";

export type Currency = "USD";
export interface StripeProductCost {
  cost: {
    amount: number; // following Stripe convention of smallest currency unit (e.g. cents for usd)
    currency: Currency; // supported currencies
  };
  currentPrice: Partial<{
    amount: number | null;
    currency: string;
    priceId: string;
    isSubscription: boolean;
    interval?: "day" | "week" | "month" | "year";
    interval_count?: number;
  }>;
}

const CURRENCY_MAP: Record<Currency, string> = {
  USD: "$",
} as const;

export const formatStripeProductCost = <T extends Partial<StripeProductCost>>(product: T): string => {
  const cost = (product.cost?.amount ?? product.currentPrice?.amount ?? 0) / 100;
  const currency = product.cost?.currency ?? product.currentPrice?.currency ?? "USD";
  return `${CURRENCY_MAP[product.cost?.currency ?? "USD"]}${cost.toFixed(2)} ${currency.toUpperCase()}${
    product.currentPrice?.isSubscription
      ? formatStripeSubscriptionInterval(product.currentPrice.interval, product.currentPrice.interval_count)
      : ""
  }`.trim();
};
